<template>
    <div class="nav">
        <div class="logo">
            <img src="../assets/logo.png" width="80" alt="">
        </div>
        <div class="nav-bar">
            <ul>
                <li>首页</li>
                <li>消息中心</li>
                <li>资讯中心</li>
                <li>服务中心</li>
            </ul>            
        </div>
        <div class="control">
            <div class="user-panel">
                <div class="userName">
                    <div class="avatar"></div>
                    <p>用户名:{{loginName}}</p>
                </div>
                <div class="dropDown">
                    <ul>
                        <li>个人中心</li>
                        <li @click="loginOut">退出</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>  
</template>

<script>
    export default {
        data() {
            return {
                loginName:""
            }
        },
        mounted() {
            this.getUserInfo();
        },
        methods: {
            // 登出
            loginOut() {
                this.$http.get('/web/base/logoutAll')
                .then(data=>{
                    if(data.data.status){
                        this.$router.push('/login')
                    }
                })
            },
            // 获取用户信息
            getUserInfo() {
                this.$http.get('/web/base/getUserInfo')
                .then(data=>{
                    this.loginName=data.data.info.loginId;
                })
            }
        },
    }
</script>

<style lang="less" scoped>
    .nav {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 6;
        padding: 0 120px;
        width: 100%;
        height: 60px;
        background: rgba(0,0,0,.6);
        display: flex;
        align-items: center;
        box-sizing: border-box;
        .logo {
            cursor: pointer;
        }
        .nav-bar {
            flex: 1;
            ul {
                margin-left: 24px;
                display: flex;
                font-size: 18px;
                color: #fff;
                li {
                    padding: 0 34px;
                    cursor: pointer;
                }
            }
        }
        .control {
            .user-panel {
                position: relative;   
                width: 180px;
                height: 60px;
                .userName {
                    height: 60px;
                    display: flex;
                    align-items: center;
                    color: #fff;
                    .avatar {
                        margin: 0 12px;
                        width: 45px;
                        height: 45px;
                        background: skyblue;
                        border-radius: 50%;
                    }
                }
                .dropDown {
                    position: absolute;
                    width: 100%;
                    ul {
                        margin: 0;
                        padding: 0;
                        
                    }
                    li {
                        padding: 14px 8px;
                        background: #fff; 
                        text-align: center;
                        &+li {
                            border-top: 1px solid #eee;
                        }
                        cursor: pointer;
                        &:hover {
                            background: rgba(0,0,0,.5);
                            color: #fff;
                        }
                    }
                    
                }
            }
        }
    }
</style>